import { HotelBedCatalogData } from '../../shared/index';
import { getAjaxhelper } from '../../utils/index';
import { HAVE_DATA_STATES, HotelRequestCheckerTool, NEED_RECHECK_STATES, TASK_COMPLETE_STATES } from '../HotelRequestCheckerTool';

/**
 * checker utnuk mengecek status available atau tidak. ini mempergunakan timer
 */
export class TimerBasedHotelRequestCheckerTool implements HotelRequestCheckerTool {
    /**
     * maksimal recheck
     */
    private maxRecheckCount: number = 1000 ; 
    /**
     * count recheck
     */
    private recheckCounter: number = 0 ; 
    /**
     * timeout untuk di clear. kalau ada sesuatu
     */
    private timeout: any = null!;
    /**
     * durasi pengecekan
     */
    private checkDuration: number = 2000 ; 
   
    /**
     * key untuk di check
     */
    private reqKey: string ;
    
    /**
     * data sebelumnya
     */
    private prevData: HotelBedCatalogData.ReqHotelAvailable = null!; 

    constructor(private parameter: {
        checkDuration?: number ; 
        /**
         * handler kalau perubahan data
         */
        onRequestHeaderDataChange?: ( requestHeader: HotelBedCatalogData.ReqHotelAvailable ) => any ; 
        /**
         * handler kalau ada error
         */
        onCheckResultError?: (exc: any ) => any; 
        /**
         * handler kalau task sudah complete
         */
        onCheckComplete: ( requestHeader: HotelBedCatalogData.ReqHotelAvailable) => any ; 

    }) {
        if ( parameter.checkDuration) {
            this.checkDuration = parameter.checkDuration ; 
        }
    }
    /**
     * ini kalau memang perlu listen akan memanggil : runCheck. kalau memang data category nya ready, ini akan kirim juga ke handler data
     * 
     */
    runCheckWithReqAvailibilityHeaderData(reqAvailableHeader: HotelBedCatalogData.ReqHotelAvailable ) {
        if ( TASK_COMPLETE_STATES.indexOf(reqAvailableHeader.statusCode!) >= 0 ) {
            this.parameter.onCheckComplete(reqAvailableHeader) ; 
            return ; 
        }
        if ( HAVE_DATA_STATES.indexOf(reqAvailableHeader.statusCode!) >= 0 ) {
            this.parameter.onRequestHeaderDataChange!(reqAvailableHeader); 
        }
        if ( NEED_RECHECK_STATES.indexOf(reqAvailableHeader.statusCode!) >= 0 ) {
            this.runCheck(reqAvailableHeader.reqKey!) ; 
        }
    }
    /**
     * start timer untuk mengecek data
     * @param reqKey 
     */
    runCheck(reqKey: string ) {
        this.stopChecker() ; 
        this.reqKey = reqKey ; 
        this.recheckCounter = 0 ; 
        this.timedCHeck(); 
    }
    /**
     * reset checker
     */
    stopChecker() {
        if ( this.timeout) {
            return ; 
        }
        try {
            clearTimeout(this.timeout); 
        } catch ( exc ) {
            //
        }
        this.timeout = null ; 
    }
    private timedCHeck() {
        this.recheckCounter += 1 ; 
        this.timeout = setTimeout( 
            d => {
                //
                getAjaxhelper().get(`/dynamics/rest-api/generic/ReqHotelAvailable/${this.reqKey}`)
                    .then( (dtl: HotelBedCatalogData.ReqHotelAvailable) => {
                        //
                        let chg: boolean = false ; 
                        if ( !this.prevData) {
                            chg = true ; 
                        } else {
                            chg = this.prevData.countBatchExecuted !== dtl.countBatchExecuted || this.prevData.statusCode !== dtl.statusCode ; 
                        }
                        this.prevData = dtl ; 
                        if ( chg) {
                            if ( this.parameter.onRequestHeaderDataChange) {
                                this.parameter.onRequestHeaderDataChange(dtl); 
                            } 
                        }
                        if ( dtl.statusCode === 'AVAILABLE' || dtl.statusCode === 'COMPLETE-WITH-ERROR' || dtl.statusCode === 'NOTAVAILABLE') {
                            this.parameter.onCheckComplete(dtl) ; 
                            return ; 
                        }
                        if ( this.recheckCounter < this.maxRecheckCount) {
                            this.timedCHeck(); 
                        } else {
                            this.parameter.onCheckComplete(dtl) ; 
                        }
                        
                    }).catch( exc => {
                        if ( this.parameter.onCheckResultError) {
                            this.parameter.onCheckResultError(exc) ;
                        } 
                        console.error('Gagal membaca data request detail, errro: ' , exc ) ; 
                    }); 
            } , 
            this.checkDuration ) ;
    }
}


// WEBPACK FOOTER //
// ./src/hotels/req-available/TimerBasedHotelRequestCheckerTool.ts